class VesselData {
  constructor(
    vessel,
    group,
    idVessel,
    vesselClass,
    IMO,
    fouling,
    consumption,
    date,
    coordinates,
    meRPM,
    mePower,
    gpsSpeed,
    logSpeed,
    avgDraft,
    mcr,
    nmcr
  ) {
    this.vessel = vessel;
    this.group = group;
    this.idVessel = idVessel;
    this.vesselClass = vesselClass;
    this.IMO = IMO;
    this.fouling = fouling;
    this.consumption = consumption;
    this.date = date;
    this.coordinates = coordinates;
    this.meRPM = meRPM;
    this.mePower = mePower;
    this.gpsSpeed = gpsSpeed;
    this.logSpeed = logSpeed;
    this.avgDraft = avgDraft;
    this.mcr = mcr;
    this.nmcr = nmcr;
  }

  getLocation() {
    return {
      latitude: this.coordinates[0],
      longitude: this.coordinates[1]
    };
  }

  getSpeedDifference() {
    return this.logSpeed - this.gpsSpeed;
  }

  isOverMCRThreshold(threshold) {
    const numericMCR = parseFloat(this.mcr);
    return !isNaN(numericMCR) && numericMCR > threshold;
  }
}

class InfoData {
  constructor(
    location,
    description,
    visible
  ) {
    this.location = location;
    this.description = description;
    this.visible = visible;
  }
}

export { VesselData, InfoData };
